import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import EmailContactsTab from './EmailContactsTab';
import EmailListsTab from './EmailListsTab';
import EmailTemplatesTab from './EmailTemplatesTab';
import EmailSendsTab from './EmailSendsTab';

const validTabs = ['contacts', 'lists', 'templates', 'sends'] as const;

const EmailMarketing: React.FC = () => {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  const activeTab = tab && (validTabs as readonly string[]).includes(tab) ? tab : 'contacts';

  return (
    <DashboardLayout
      title={<><i className="bi bi-envelope-fill me-2"></i>Email Marketing</>}
      scrollable
    >
      <Tabs activeKey={activeTab} onSelect={(k) => k && navigate(`/email-marketing/${k}`)} mountOnEnter unmountOnExit>
        <Tab eventKey="contacts" title={<><i className="bi bi-envelope me-2"></i>Contacts</>}>
          <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
            <EmailContactsTab />
          </div>
        </Tab>
        <Tab eventKey="lists" title={<><i className="bi bi-list-ul me-2"></i>Lists</>}>
          <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
            <EmailListsTab />
          </div>
        </Tab>
        <Tab eventKey="templates" title={<><i className="bi bi-envelope-paper me-2"></i>Email Templates</>}>
          <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
            <EmailTemplatesTab />
          </div>
        </Tab>
        <Tab eventKey="sends" title={<><i className="bi bi-send me-2"></i>Sends</>}>
          <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
            <EmailSendsTab />
          </div>
        </Tab>
      </Tabs>
    </DashboardLayout>
  );
};

export default EmailMarketing;
